module.exports = __webpack_public_path__ + "static/media/page02_two_lady.6bd58f74.gif";